module.exports = __webpack_public_path__ + "static/media/submetrics-decrement-arrow.3775c0f8.svg";